/**
 * factoredInteger()로 유지할 소수 자릿수.
 * 치수를 정수 단위로 스케일링해 부동소수 오차를 제거한다. (1 factored unit = 1e-5 mm)
 */
const FACTOR = 5;

/**
 * 값을 FACTOR 배 하여 가장 가까운 정수로 반올림한다.
 * null/undefined는 0으로 처리한다. (무게 미지정 등)
 */
export const factoredInteger = (value) => (
    Math.round(Number(value || 0) * (10 ** FACTOR))
);
